import { useMutation } from 'react-query';
import { rejectInvitation } from 'src/services/api/invitations';

function useRejectInvitation() {
  return useMutation((invitation) => rejectInvitation(invitation));
}

export default useRejectInvitation;
